
<template>
<b-overlay
      :show="loading"
      spinner-variant="primary"
      spinner-type="grow"
      spinner-small
      rounded="sm"
    >
  <div>
    <b-card title="Informations générales">
       <validation-observer ref="simpleRules">
        <b-form
          @submit.prevent
        >
        <b-row>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Nom"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Nom"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.name"
                :plaintext="readOnly"
                placeholder="Nom"
                :state="errors.length > 0 ? false:null"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
            <b-form-group
              label="Description"
              label-for="basicInput"
            >
             <validation-provider
              #default="{ errors }"
              name="Description"
              rules="required"
            >
              <b-form-input
              required
                id="basicInput"
                v-model="form.description"
                :plaintext="readOnly"
                placeholder="Description"
                :state="errors.length > 0 ? false:null"
              />
               <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
          <b-col
            md="6"
            xl="4"
            class="mb-1"
          >
          <b-form-group
              label="Prix"
              label-for="Prix"
            >
            <validation-provider
              #default="{ errors }"
              name="Prix"
              rules="required"
            >
              <b-form-input
              required
                id="Prix"
                v-model="form.price"
                :plaintext="readOnly"
                type="number"
                step="0.01"
                :state="errors.length > 0 ? false:null"
                placeholder="Prix"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </b-form>
      </validation-observer>

    </b-card>

    <b-button v-if="edition==false"
     @click="createRefinement"
    >
    Enregistrer
    </b-button>

    <b-button v-else
     @click="editRefinement"
    >
    Enregistrer
    </b-button>

  </div>
</b-overlay>
</template>

<script>
import { BButton,BFormInput, BForm, BRow, BOverlay, BCol, BFormGroup,BFormFile, BCard, BFormCheckbox, BFormTextarea} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import vSelect from 'vue-select'
import {APIRequest} from '@simb2s/senseye-sdk'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required, email } from '@validations'

export default {
  name: 'RefinementForm',
  components: {
    BButton,
    BFormInput,
    BFormGroup,
    BRow,
    BCol,
    BOverlay,
    BFormFile,
    BCard,
    BFormCheckbox,
    BFormTextarea,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    BForm
  },
  data() {
      return {
          edition:false,
          currentBase64:null,
          loading:true,
          file: null,
          form:{
            name:"",
            price:0,
            description:''
          },
      }
  },
  props: ['refinement', 'readOnly'],
  methods:{
    async createRefinement()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
        
          await APIRequest.create('refinements',this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'affinement a bien été créé !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'refinements'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
    async editRefinement()
    {
       this.$refs.simpleRules.validate().then(async success => {
        if (success) {
        this.loading=true
        try {
        
          await APIRequest.update('refinements',this.refinement.id,this.form)
          this.$toast({
            component: ToastificationContent,
            props: {
              title: "L'affinement a bien été modifié !",
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
          this.$router.push({name:'refinements'})
        } catch (error) {
          this.loading=false
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Une erreur est survenue.',
              icon: 'AlertCircleIcon',
              variant: 'warning',
            },
          })
          
        }
        }
       })
      
    },
 
  },
    
  async mounted(){
   if(this.refinement!=null)
    {
      this.form=this.refinement
      this.edition=true
    }
    this.loading=false
  }

}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
</style>